import React, { useState, useEffect } from 'react'
import Drawer from 'components/Drawer'
import { FlexWrap } from 'modules/Roles/NewRoleCreation/Partials/AllCollegeDrawer/Style/style'
import { Input, Spin } from 'antd'
import Button from 'components/Button'
import { GroupFilters } from './Partials/Filters'
import { GroupTable } from './Partials/Table'
import { Map } from './Partials/Map'
import { CollegeChart } from './Partials/Chart'
import {
  PlusOutlined,
  CopyOutlined,
  DeleteOutlined,
  CloseOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import {
  GroupCreationWrapper,
  MainContent,
  InputSection,
  FilterSection,
  TableSection,
  AnalyticsSection,
  GroupDrawerText,
} from './style'
import AddCollege from '../../../../../../../components/icons/AddCollege'
import DuplicateGroup from '../../../../../../../components/icons/DuplicateGroup'
import DeleteBin from '../../../../../../../components/icons/DeleteBin'

const GroupCreation = ({
  visible,
  onClose,
  setGroupName,
  groupName,
  createGroup,
  updateGroup,
  deleteGroup,
  selectedInstitute,
  setSelectedInstitute,
  groupDetails,
  groupId,
  oneGroupDetail,
  instituteCampusList,
  setInstituteCampusList,
  removeInstituteFromGroup,
  handleEditTier,
  handleEditPOC,
  showDeleteGroupPopup,
  setPopupConfig,
  popupConfig,
  showRemoveInstitutePopup,
  showDuplicatePopup,
  selectedGroupPagination,
  setSelectedGroupInstitutePagination,
  setGroupsInstituteCampusIds,
  onAddCollegeClick,
  groupInstFilterData,
  fetchGroupDetails,
  setGroupInstFilterData,
  groupBackup,
  setGroupBackup,
  groupInstListSelectedFilter,
  setGroupInstListSelectedFilter,
  onPageChange,
  selectedGroupInstitutePagination,
  getDraftSelectList,
  fetchGroupList,
  fetchMapMetrics,
  chartMetrics,
  mapMetrics,
  groupStateOptions = [],
  groupCityOptions = [],
  onGroupStateSearch,
  onGroupCitySearch,
  onGroupStateDropdownClose,
  onGroupCityDropdownClose,
  selectedColleges,
  handleSort,
}) => {
  const [loading, setLoading] = useState(false)
  const [filterTriggered, setFilterTriggered] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')  
  useEffect(() => {
    if (groupId) {
      ;(async () => {
        await fetchGroupDetails(
          {},
          selectedGroupInstitutePagination?.currentPage
        )
        await fetchMapMetrics(groupId)
      })()
    }
  }, [groupId])

  const onSave = async () => {
    const payloadInstituteIds = !groupId
      ? Array.isArray(selectedColleges)
        ? selectedColleges.map(item => item?.instituteCampusId)
        : []
      : Array.isArray(instituteCampusList)
      ? groupDetails?.instituteCampusIds
      : []
    const payload = {
      id: groupId,
      groupName: groupName,
      instituteCampusIds: payloadInstituteIds ?? [],
    }
    if (!groupId) {
      await createGroup(payload)
    } else {
      await updateGroup(payload)
    }
    await onClose()
    await fetchGroupList()
  }
  const tierData = [
    { id: '1', name: 'Tier 1', value: 1 },
    { id: '2', name: 'Tier 2', value: 2 },
    { id: '3', name: 'Tier 3', value: 3 },
    { id: '4', name: 'Tier 4', value: 4 },
  ]

  const handleGroupFilterChange = (val, key) => {
    setFilterTriggered(true)
    setGroupInstListSelectedFilter(prev => ({
      ...prev,
      [key]: val,
    }))
  }

  useEffect(() => {
    const run = async () => {
      try {
        if (groupId) {
          setTableLoading(true)
          await fetchGroupDetails(
            { triggerFromFilter: true },
            selectedGroupInstitutePagination?.currentPage
          )
        } else if (filterTriggered && !groupId) {
          setTableLoading(true)
          await getDraftSelectList(1, 10, true, groupInstListSelectedFilter)
        }
      } finally {
        setTableLoading(false)
        setFilterTriggered(false)
      }
    }
    run()
  }, [groupInstListSelectedFilter, groupId, filterTriggered])

  const content = () => (
    <>
      {!loading ? (
        <GroupCreationWrapper>
          <InputSection>
            <div
              style={{
                marginRight: '16px',
                width: '40%',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <GroupDrawerText>Group Name *</GroupDrawerText>
              <Input
                placeholder="Enter Group Name"
                style={{
                  marginRight: '16px',
                  borderRadius: '10px',
                  backgroundColor: '#FAFAFB',
                  height: '48px',
                }}
                value={groupName}
                onChange={e => setGroupName(e.target.value)}
                maxLength={50}
              />
            </div>
            <div
              style={{
                padding: '10px',
                display: 'flex',
                gap: '10px', // or any spacing you like
                alignItems: 'center',
              }}
            >
              <AddCollege onClick={onAddCollegeClick} />
              <DuplicateGroup
                onClick={() => showDuplicatePopup(groupBackup)}
                disabled={!groupId}
              />
              <DeleteBin onClick={showDeleteGroupPopup} disabled={!groupId} />
            </div>
          </InputSection>

          <FilterSection>
            <GroupFilters
              groupStateOptions={groupStateOptions}
              groupCityOptions={groupCityOptions}
              onGroupStateSearch={onGroupStateSearch}
              onGroupCitySearch={onGroupCitySearch}
              onGroupStateDropdownClose={onGroupStateDropdownClose}
              onGroupCityDropdownClose={onGroupCityDropdownClose}
              groupInstFilterData={groupInstFilterData}
              tierData={tierData}
              groupInstListSelectedFilter={groupInstListSelectedFilter}
              onGroupFilterChange={handleGroupFilterChange}
            />
          </FilterSection>

          <MainContent>
            <TableSection>
              <GroupTable
                selectedInstitute={selectedInstitute}
                setSelectedInstitute={setSelectedInstitute}
                instituteCampusList={instituteCampusList}
                onRemoveInstitutes={showRemoveInstitutePopup}
                setTableLoading={setTableLoading}
                tableLoading={tableLoading}
                handleEditTier={handleEditTier}
                handleEditPOC={handleEditPOC}
                totalItems={selectedGroupPagination?.totalItems}
                pageNum={selectedGroupPagination?.currentPage}
                pageLimit={selectedGroupPagination?.pageLimit}
                onGroupFilterChange={handleGroupFilterChange}
                groupInstFilterData={groupInstFilterData}
                onPageChange={onPageChange}
                handleSort={handleSort}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
            </TableSection>
            <AnalyticsSection>
              <Map mapMetrics={mapMetrics} />
              <CollegeChart chartMetrics={chartMetrics} />
            </AnalyticsSection>
          </MainContent>
        </GroupCreationWrapper>
      ) : (
        <FlexWrap center>
          <Spin />
        </FlexWrap>
      )}
    </>
  )

  const footer = () => (
    <FlexWrap right>
      <Button.Secondary text="Cancel" onClick={
        () => {
          onClose()
          setSearchValue('')
        } } />
      <Button.Primary
        text="Save Group"
        onClick={onSave}
        disabled={
          !groupName || groupName?.trim() == '' || !instituteCampusList?.length
        }
      />
    </FlexWrap>
  )

  return (
    <>
      <Drawer
        zIndex={3000}
        width="90%"
        padding="0px 30px"
        title={!groupId ? 'Create a New Group' : 'Edit Group'}
        placement="right"
        onClose={ () => {
          onClose()
          setSearchValue('')
        } }
        closable={true}
        visible={visible}
        content={content()}
        footer={footer()}
      />
    </>
  )
}

export default GroupCreation
